import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../api";

function ReconciliationReopenPage() {
  const { id } = useParams(); // the Reconciliation's ID
  const navigate = useNavigate();
  const [reconciliation, setReconciliation] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchReconciliation(id);
  }, [id]);

  async function fetchReconciliation(recId) {
    try {
      const res = await API.get(`/reconciliations/${recId}?limit=100000`);
      setReconciliation(res.data.reconciliation);
    } catch (err) {
      console.error("Fetch Reconciliation Error:", err);
      setError("Failed to load reconciliation");
    }
  }

  async function handleReopen() {
    if (!window.confirm("Are you sure you want to re-open this reconciliation?")) {
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await API.post(`/reconciliations/reopen/${id}`);
      alert(res.data.message);
      navigate("/reconciliations");
    } catch (err) {
      console.error("Re-open error:", err);
      setError("Failed to re-open reconciliation.");
    } finally {
      setLoading(false);
    }
  }

  if (!reconciliation && !error) {
    return <div>Loading data...</div>;
  }

  return (
    <div className="container">
      <h2>Re-Open Reconciliation</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}

      {reconciliation && (
        <>
          <p>
            Reconciliation #{reconciliation._id} for account:{" "}
            {reconciliation.account?.accountName} on{" "}
            {new Date(reconciliation.date).toLocaleDateString()}.
          </p>
          <p>
            Current status: {reconciliation.status}, variance:{" "}
            {reconciliation.variance}
          </p>
          <p>
            This will unlock the account, reverse any surplus/deficit for that
            date, and allow Admin to backdate transactions.
          </p>
        </>
      )}

      <button onClick={handleReopen} disabled={loading}>
        {loading ? "Re-Opening..." : "Confirm Re-Open"}
      </button>
    </div>
  );
}

export default ReconciliationReopenPage;
